import React from "react";
import { ReactComponent as MasterIcon } from "../../../../inlineSvgs/master.svg";
import { ReactComponent as ArrowIcon } from "../../../../inlineSvgs/arrow-right-2.svg";
import { Link } from "react-router-dom";

const SelectMaster = ({ master }) => {
  return (
    <Link to="/booking/master" className="select-master order-param">
      <MasterIcon />
      {master ? (
        <div className="master-info info">
          <div className="title">{master.firstName} {master.lastName}</div>
          <div className="sub-title">{master.skills.length && master.skills[0].rank}</div>
        </div>
      ) : (
        <div className="not-info">
          <div className="title">Select Master</div>
          <div className="sub-title">Let’s use it before it’s burnt</div>
        </div>
      )}
      <ArrowIcon />
    </Link>
  );
};

export default SelectMaster;
